import {Directive, ElementRef, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

const I18NAttributeWhitelist = ['placeholder', 'title', 'label', 'value', 'notFoundText'];
type I18nParam = { target: string, key: string, params?: Object };

@Directive({
    selector: '[i18nKey]',
    standalone: false
})
export class I18nTranslateDirective {
    constructor(
        private readonly el: ElementRef,
        private readonly translateService: TranslateService
    ) {
    }

    @Input()
    set i18nKey(i18n: I18nParam[] | string) {
        if (typeof i18n === 'string') {
            this.updateInnerHTML(i18n);
        } else {
            i18n.forEach(item => {
                if (item.key) {
                    this.usage(item);
                    if (item.target !== 'innerHTML') {
                        this.updateAttribute(item);
                    } else {
                        this.updateInnerHTML(item.key, item.params);
                    }
                }
            });
        }
    }

    private usage(item: I18nParam) {
        const attr = item.target.split(':');
        if ((attr[0] !== 'innerHTML' && attr[0] !== 'attribute') ||
            (attr[1] && !(I18NAttributeWhitelist.includes(attr[1])))) {
            throw Error(
                'Bad signature for the i18n directive on {' + item.target + ', ' + item.key + ', ' + JSON.stringify(item.params) + '}, ' +
                'target should be innerHTML or attribute:<your attribute> ' +
                'with attribute in [' + I18NAttributeWhitelist + ']'
            );
        }
    }

    private updateInnerHTML(key: string, params?: Object) {
        this.el.nativeElement.setAttribute('data-i18n-key', key);
        this.el.nativeElement.setAttribute('data-i18n-args', base64Encode(JSON.stringify(params || {})));
        this.translateService.stream(key, params || {})
            .subscribe(res => this.el.nativeElement.innerHTML = res);
    }

    private updateAttribute(params: I18nParam) {
        const target = params.target.split(':')[1];
        this.el.nativeElement.setAttribute('data-i18n-' + target + '-key', params.key);
        this.el.nativeElement.setAttribute('data-i18n-' + target + '-args', base64Encode(JSON.stringify(params.params ? params.params : {})));
        this.translateService.stream(params.key, params.params ? params.params : {})
            .subscribe(res => this.el.nativeElement.setAttribute(target, res));
    }
}

function base64Encode(str: string) {
    return btoa(unescape(encodeURIComponent(str)))
}
